module.exports = __webpack_public_path__ + "img/TheForttunaGroup.ccf44adb.jpg";